import authenticationService  from '../services/authentication.service';
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : handleResponse
Description : Pagina de handleResponse para validar el logueo del los usuarios.
Date Autor Modification
================================================================================
2/11/2021 Cristian Andres Pizo Mina - Pagina de handleResponse.
================================================================================ */
export function handleResponse(response) {
    
    if (!response.status) {
        if ([401, 403].indexOf(response.status) !== -1) {
            // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
            authenticationService.logout();
        }

        const error = (response.data && response.data.message) || response.statusText;
        return Promise.reject(error);
    }
    // console.log(response)
    return response;

}